export default "__VITE_ASSET__2857b91e__"